/* eslint-disable no-plusplus */
import { call, putResolve, select, takeLatest } from 'redux-saga/effects';
import {
  saveEdit,
  saveEditSuccess,
} from '../actions';
import { updatePath } from '../actions/pathActions';
import areaInSquareFeet from '../api/areaInSquareFeet';

import { roomMeasureSelector } from '../selectors/roomMeasure';
import { configuratorChoices, configuratorOptions } from '../selectors/configurator';
import { pricingNodeSelector } from '../selectors/pricing';
import { findTaggedValue } from '../utils/tags';
import getSelectedCarpetChoice from '../utils/getSelectedCarpetChoice';
import { trackEnterRoomsEditRoom } from '../utils/analytics/trackEvents';
import { EXTRA_AREA } from '../utils/constants';
import safeSaga from './safeSaga';

function* custompayload(gasFee) {
  const choices = yield select(configuratorChoices);
  const options = yield select(configuratorOptions);
  const { choicesWithPrices } = yield select(pricingNodeSelector);
  const { measure } = yield select(roomMeasureSelector);

  const selectedCarpetChoice = yield getSelectedCarpetChoice(options, choices);
  const rollWidth = selectedCarpetChoice
    ? findTaggedValue(selectedCarpetChoice.tags, 'carpetwidth') : 12;
  const selectedChoice = yield selectedCarpetChoice && selectedCarpetChoice.id ? selectedCarpetChoice.id : 0;
  const padPrice = measure.length > 0 && measure[0]?.measure ? measure[0]?.padPrice : 0;

  const selectedCarpet =
    yield choicesWithPrices && choicesWithPrices.filter((withPrice) => withPrice.id === selectedChoice);
  const selectedCarpetPrice = yield selectedCarpet[0] ? selectedCarpet[0].priceSquareYard : selectedChoice;

  const paycharge = gasFee;
  const length = yield Number(paycharge.lengths);
  const width = yield Number(paycharge.widths);
  const data = yield call(areaInSquareFeet, paycharge.ids, length, width, rollWidth);
  const sqFt = yield Math.round(Number(data.areaInSquareFeet) * EXTRA_AREA);
  const carpetPadPrice = yield padPrice > 0 ? (padPrice * sqFt).toFixed(2) : padPrice;
  const price = yield selectedCarpetPrice;
  const squarePrice = ((sqFt / 9) * price).toFixed(2);
  const totalPrice = yield (+squarePrice + +carpetPadPrice).toFixed(2);

  trackEnterRoomsEditRoom(yield paycharge.ids, Math.round(sqFt));

  return {
    id: yield paycharge.ids,
    room: yield paycharge.rooms,
    length,
    width,
    sqFt: Math.round(sqFt),
    price,
    squarePrice,
    carpetPadPrice,
    padPrice,
    totalPrice,
  };
}

export function* editRoom(action) {
  const { measure } = yield select(roomMeasureSelector);
  const idx = yield measure.findIndex((item) => item.id === action.payload.ids);
  const newMeasures = yield [...measure];
  newMeasures[idx] = yield custompayload(action.payload);

  yield putResolve(saveEditSuccess(newMeasures));
  yield putResolve(updatePath());
}

export function* editRoomSaga() {
  yield takeLatest(saveEdit.toString(), safeSaga(editRoom));
}
